import * as React from "react";
import { ClinicOnboardView } from "./clinicOnboardView";
import { useLocation } from "react-router-dom";
import { VerifyCodeWidget } from "user-management/src/components/verifyCodeWidget";
//region [[ Styles ]]

//endregion [[ Styles ]]
//region [[ Props ]]
export interface ClinicVerifySignUpProps {
  onComplete: () => void;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const ClinicVerifySignUp = ({ ...props }: ClinicVerifySignUpProps) => {
  const { search } = useLocation();

  const params = new URLSearchParams(search);

  const code = params.get("code") ? params.get("code").replace(/N/g, "") : null;

  console.log("received verification code", code);

  return (
    <ClinicOnboardView>
      {!code ? (
        <div>This link is invalid</div>
      ) : (
        <VerifyCodeWidget
          hideLogo
          code={code}
          userName={params.get("username")}
          onComplete={props.onComplete}
        />
      )}
    </ClinicOnboardView>
  );
};
